// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1rgO5","header":"ReportDetails_header__1OqmO","title":"ReportDetails_title__2VvB8","left":"ReportDetails_left__44x8D"};